import { LocalEvents } from '../../local-events'
import { SettingsCustomMenuItem } from './settings-custom-menu-item'

const FONT_FAMILY_OPTIONS = [
  'default',
  'monospaced_serif',
  'proportional_serif',
  'monospaced_sans_serif',
  'proportional_sans_serif',
  'casual',
  'cursive',
  'small_capitals',
]

const FONT_COLOR_OPTIONS = [
  'white_color',
  'black_color',
  'red_color',
  'green_color',
  'blue_color',
  'yellow_color',
  'magenta_color',
  'cyan_color',
]

const FONT_SIZE_OPTIONS = ['50', '75', '100', '150', '200']

const FONT_OPACITY_OPTIONS = ['50', '100']

const BACKGROUND_COLOR_OPTIONS = [
  'white_color',
  'black_color',
  'red_color',
  'green_color',
  'blue_color',
  'yellow_color',
  'magenta_color',
  'cyan_color',
]

const BACKGROUND_OPACITY_OPTIONS = ['0', '10', '50', '100']

const WINDOW_COLOR_OPTIONS = [
  'white_color',
  'black_color',
  'red_color',
  'green_color',
  'blue_color',
  'yellow_color',
  'magenta_color',
  'cyan_color',
]

const WINDOW_OPACITY_OPTIONS = ['0', '50', '100']

const CHARACTER_EDGE_STYLE_OPTIONS = [
  'none',
  'raised',
  'depressed',
  'uniform',
  'drop_shadow',
]

export const getFontFamilyMenuItems = () => {
  return FONT_FAMILY_OPTIONS.map((option) => {
    return SettingsCustomMenuItem.as('settingsCustomMenuItem', {
      value: option,
      settingKey: 'fontFamily',
      settingValue: option,
      back: LocalEvents.SettingsActivateSubtitlesFontFamilyMenu,
    })
  })
}

export const getFontColorMenuItems = () => {
  return FONT_COLOR_OPTIONS.map((option) => {
    return SettingsCustomMenuItem.as('settingsCustomMenuItem', {
      value: option,
      settingKey: 'fontColor',
      settingValue: option.replace('_color', ''),
      back: LocalEvents.SettingsActivateSubtitlesFontColorMenu,
    })
  })
}

export const getFontSizeMenuItems = () => {
  return FONT_SIZE_OPTIONS.map((option) => {
    return SettingsCustomMenuItem.as('settingsCustomMenuItem', {
      value: option + '%', // Display with percentage
      settingKey: 'fontSize',
      settingValue: option,
      back: LocalEvents.SettingsActivateSubtitlesFontSizeMenu,
    })
  })
}

export const getFontOpacityMenuItems = () => {
  return FONT_OPACITY_OPTIONS.map((option) => {
    return SettingsCustomMenuItem.as('settingsCustomMenuItem', {
      value: option + '%', // Display with percentage
      settingKey: 'fontOpacity',
      settingValue: option,
      back: LocalEvents.SettingsActivateSubtitlesFontOpacityMenu,
    })
  })
}

export const getBackgroundColorMenuItems = () => {
  return BACKGROUND_COLOR_OPTIONS.map((option) => {
    const value = option.replace('_color', '')
    return SettingsCustomMenuItem.as('settingsCustomMenuItem', {
      value: option, // 'white_color', 'black_color', etc - будет локализоваться
      settingKey: 'backgroundColor',
      settingValue: value, // 'white', 'black', etc - сохраняется в settings
      back: LocalEvents.SettingsActivateSubtitlesBackgroundColorMenu,
    })
  })
}

export const getBackgroundOpacityMenuItems = () => {
  return BACKGROUND_OPACITY_OPTIONS.map((option) => {
    return SettingsCustomMenuItem.as('settingsCustomMenuItem', {
      value: option + '%', // Display with percentage
      settingKey: 'backgroundOpacity',
      settingValue: option,
      back: LocalEvents.SettingsActivateSubtitlesBackgroundOpacityMenu,
    })
  })
}

export const getWindowColorMenuItems = () => {
  return WINDOW_COLOR_OPTIONS.map((option) => {
    const value = option.replace('_color', '')
    return SettingsCustomMenuItem.as('settingsCustomMenuItem', {
      value: option, // 'white_color', 'black_color', etc - будет локализоваться
      settingKey: 'windowColor',
      settingValue: value, // 'white', 'black', etc - сохраняется в settings
      back: LocalEvents.SettingsActivateSubtitlesWindowColorMenu,
    })
  })
}

export const getWindowOpacityMenuItems = () => {
  return WINDOW_OPACITY_OPTIONS.map((option) => {
    return SettingsCustomMenuItem.as('settingsCustomMenuItem', {
      value: option + '%', // Display with percentage
      settingKey: 'windowOpacity',
      settingValue: option,
      back: LocalEvents.SettingsActivateSubtitlesWindowOpacityMenu,
    })
  })
}

export const getCharacterEdgeStyleMenuItems = () => {
  return CHARACTER_EDGE_STYLE_OPTIONS.map((option) => {
    return SettingsCustomMenuItem.as('settingsCustomMenuItem', {
      value: option,
      settingKey: 'characterEdgeStyle',
      settingValue: option,
      back: LocalEvents.SettingsActivateSubtitlesCharacterEdgeStyleMenu,
    })
  })
}

export const formatTextTrack = (
  track: TextTrack,
  localize: (key: string) => string
) => {
  let label = track.label || track.language || 'Unknown'

  if (track.kind === 'captions') {
    label += ` (${localize('closed_captions')})`
  }

  // console.log('formatTextTrack label', label)

  return { ...track, label }
}
